import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import * as AntvLayout from '@antv/layout';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
/** 画布图数据执行布局算法命令 */
export var NsGraphLayout;
(function (NsGraphLayout) {
    /** Command: 用于注册named factory */
    NsGraphLayout.command = XFlowGraphCommands.GRAPH_LAYOUT;
    /** hookName */
    NsGraphLayout.hookKey = 'graphLayout';
})(NsGraphLayout || (NsGraphLayout = {}));
let GraphLayoutCommand = 
/** 画布布局命令 */
class GraphLayoutCommand {
    constructor() {
        /** 执行cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.graphLayout.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { layoutType, layoutOptions, customLayout } = handlerArgs;
                /** XFlow内置AntV通用布局 */
                const innerLayout = (graphData) => {
                    const clz = AntvLayout.Layouts[layoutType];
                    const antVLayout = new clz(Object.assign({}, layoutOptions));
                    return antVLayout.layout(graphData);
                };
                const layoutFunc = customLayout || innerLayout;
                yield layoutFunc(handlerArgs.graphData);
                return { graphData: handlerArgs.graphData };
            }), runtimeHook);
            /** 设置结果 */
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphLayoutCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphLayoutCommand.prototype, "init", null);
GraphLayoutCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphLayout.command.id },
    })
    /** 画布布局命令 */
], GraphLayoutCommand);
export { GraphLayoutCommand };
//# sourceMappingURL=graph-layout.js.map